import { useNavigate } from 'react-router-dom';

import { useCreateActionsMutation } from '../api';

import type { MessageCreateModel } from '@/features/Shared/model/types/message-create.model';

import { CreateFormLayout } from '@/features/Shared/forms';

export const CreateActionLayout = () => {
	const navigate = useNavigate();
	const [create] = useCreateActionsMutation();
	const handleSubmit = async (data: MessageCreateModel) => {
		try {
			await create(data).unwrap();
			navigate('/actions');
		} catch {
			// Handle error (e.g., show a notification)
		}
	};

	return (
		<CreateFormLayout
			title="Create Action"
			buttonText="Send Action"
			value={
				{
					content: {
						title: {
							text: '',
						},
						body: {
							text: '',
						},
					},
					recipientGroups: [
						{
							groupNumber: 0,
							orgId: '',
							recipients: [],
						},
					],
				} as MessageCreateModel
			}
			onSubmit={handleSubmit}
		/>
	);
};
